import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { MailService } from '@services';
import UiValidators, { UI_EMAIL_MAX_LENGTH } from '@validators';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
var MailModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MailModalComponent, _super);
    function MailModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this._appState = _this._injector.get(AppStateFacade);
        _this._mailService = _this._injector.get(MailService);
        _this._sendTo = _this._appState.user.value.emailAddress;
        return _this;
    }
    MailModalComponent.prototype.ngOnInit = function () {
        this.form = this._injector.get(FormBuilder).group({
            'sendTo': [
                this._sendTo,
                Validators.compose([
                    UiValidators.required(),
                    Validators.email,
                    Validators.maxLength(UI_EMAIL_MAX_LENGTH),
                ])
            ],
        });
    };
    MailModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.form.valid || this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        this._sendTo = this.form.value.sendTo;
        this._mailService.send(this._sendTo, this.context.data)
            .pipe(finalize(function () { return _this.loading$.next(false); }))
            .subscribe({
            error: function () {
                return _this._dialogRef.close({
                    type: 5 /* Failed */,
                });
            },
            complete: function () {
                return _this._dialogRef.close({
                    type: 4 /* Succeeded */,
                    additionalData: _this._sendTo,
                });
            },
        });
    };
    return MailModalComponent;
}(UiModalComponent));
export { MailModalComponent };
